export default {
    updateShipper(state, payload) {
        state.Shipper = payload;
    },

    updateShippers(state, payload) {
        state.Shippers = payload;
    }
}